import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import withMetatag from '../../../../decorators/metadataDecorators/metatagsTitleDecorator';

import Info from '../../../SEO_pages/Topic/Info';

import { setWatchlistLoadStatus } from '../../../../actions/watchlistActions';

const InfoComponent = ({ slug, assetType }) => {
  const dispatch = useDispatch();
  const step = useSelector((state) => state.watchlistReducer.wlPageLoadingStep);

  useEffect(() => {
    if (step === 'LOADED') {
      return;
    }

    dispatch(setWatchlistLoadStatus('LOADED'));
  }, [step, dispatch]);

  return !!slug && (
    <Info slug={slug} assetType={assetType} />
  );
};

export default withMetatag(InfoComponent, 'watchlists/info');
